import * as React from 'react';

function SvgSetPointH(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.2 12" {...props}>
      <path d="M1 1.7h1.5v8.6H1zM6.3 1.7h1.5v8.6H6.3z" />
      <path d="M1 5.4h6.8v1.2H1zM9.2 1.8c-.5.3-.6.8-.3 1.3s.8.6 1.3.4.6-.8.3-1.3-.9-.6-1.3-.4zM9.9 3c-.2.1-.5.1-.6-.1-.1-.2 0-.5.2-.6.2-.2.4-.1.5.1.2.2.1.5-.1.6zM10.7 4.5c-.4.3-.6.8-.3 1.3s.8.6 1.3.4c.4-.3.6-.8.3-1.3-.2-.5-.8-.7-1.3-.4zm.8 1.2c-.2.1-.5.1-.6-.1-.1-.2 0-.5.2-.6.2-.1.5-.1.6.1 0 .2 0 .5-.2.6zM8.69 4.59l3.096-1.835.357.602-3.097 1.835z" />
    </svg>
  );
}

export default SvgSetPointH;
